<span (click)="clickFile()" class="file-text btn-cursor text-truncate">
  {{ _fileInfo?.file?.filename }}
</span>
<font-awesome (click)="delete()"
              *ngIf="_fileInfo?.file && _deletable" [cssClass]="'ml-4px'"
              [icon]="'fa-regular fa-xmark'" role="button"></font-awesome>

<div (click)="imgFileInput.click()" *ngIf="!_fileInfo?.file && !roles.cdCreator.includes(_initInfo?.userType)"
     class="item-file btn-cursor">
  <input disabled hidden name="filename" placeholder="Select a File">
  <input #imgFileInput (change)="fileSelected($event)" hidden multiple type="file"/>
  <font-awesome [cssClass]="'icon-21px'" [icon]="'fa-light fa-image'" id="select-icon" role="button"></font-awesome>
</div>

